import { Card, CardContent } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { HelpCircle } from 'lucide-react';

export const FAQSection = () => {
  const faqs = [
    {
      question: "Quels types de véhicules industriels vendez-vous ?",
      answer: "Nous proposons une large gamme de véhicules industriels d'occasion : camions porteurs, tracteurs routiers, semi-remorques, utilitaires et matériel industriel. Tous nos véhicules sont rigoureusement contrôlés et conformes aux normes Euro en vigueur."
    },
    {
      question: "Vos véhicules sont-ils garantis ?",
      answer: "Oui, tous nos véhicules d'occasion bénéficient d'une garantie. La durée et les conditions varient selon le véhicule. Nous proposons également des extensions de garantie pour votre tranquillité d'esprit."
    },
    {
      question: "Proposez-vous des solutions de financement ?",
      answer: "Oui, nous travaillons avec plusieurs partenaires financiers pour vous proposer des solutions de financement adaptées à votre situation : crédit classique, LOA, LLD. Contactez-nous pour une étude personnalisée."
    },
    {
      question: "Puis-je reprendre mon ancien véhicule en échange ?",
      answer: "Absolument ! Nous acceptons les reprises de véhicules industriels. Notre équipe évalue votre véhicule actuel et vous propose un prix de reprise compétitif qui viendra en déduction du prix d'achat."
    },
    {
      question: "Où êtes-vous situés ?",
      answer: "Notre établissement est situé à Val-de-Meuse (52140) en Haute-Marne, facilement accessible depuis Chaumont, Langres et les départements limitrophes. Nous recevons sur rendez-vous pour vous garantir un accueil personnalisé."
    },
    {
      question: "Quelle est la différence entre Euro 5 et Euro 6 ?",
      answer: "Les normes Euro définissent les limites d'émissions polluantes. L'Euro 6 est la norme la plus récente et la plus stricte, avec des émissions de NOx et de particules réduites de 80% par rapport à l'Euro 5. Les véhicules Euro 6 ont également une meilleure vignette Crit'Air, permettant l'accès aux zones à faibles émissions."
    },
    {
      question: "Comment obtenir la vignette Crit'Air pour mon camion ?",
      answer: "La vignette Crit'Air classe les véhicules selon leurs émissions polluantes. Elle est obligatoire pour circuler dans les zones à faibles émissions (ZFE). Vous pouvez la commander sur le site officiel certificat-air.gouv.fr. Nous vous aidons à déterminer la classification Crit'Air de chaque véhicule avant l'achat."
    },
    {
      question: "Effectuez-vous l'entretien et les réparations ?",
      answer: "Oui, nous disposons d'un atelier équipé et d'une équipe de mécaniciens expérimentés. Nous assurons l'entretien courant, les révisions et les réparations sur tous types de véhicules industriels."
    },
    {
      question: "Puis-je essayer le véhicule avant l'achat ?",
      answer: "Bien sûr ! Nous encourageons les essais sur route pour que vous puissiez évaluer le véhicule dans des conditions réelles. Prenez rendez-vous avec nous pour organiser un essai adapté à vos besoins."
    },
    {
      question: "Quels documents fournis-tu à la vente ?",
      answer: "À la vente, nous fournissons : certificat de cession, carte grise barrée, procès-verbal de contrôle technique de moins de 6 mois, carnet d'entretien si disponible, et tous les documents relatifs à la garantie. Nous nous occupons également des démarches administratives."
    },
    {
      question: "Livrez-vous les véhicules ?",
      answer: "Oui, nous proposons un service de livraison partout en France et en Europe. Les frais de livraison varient selon la distance. Contactez-nous pour un devis personnalisé."
    },
    {
      question: "Comment connaître l'historique d'un véhicule ?",
      answer: "Nous fournissons un historique complet pour chaque véhicule : nombre de propriétaires précédents, carnet d'entretien, historique des révisions, et rapport sur les éventuels accidents. La transparence est notre priorité."
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50" id="faq">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-4">
            <HelpCircle className="h-8 w-8 text-white" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Questions Fréquentes
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trouvez les réponses aux questions les plus courantes sur l'achat de véhicules industriels d'occasion
          </p>
        </div>

        <Card className="border-0 shadow-xl">
          <CardContent className="p-6">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-left hover:text-blue-600 transition-colors">
                    <span className="font-semibold">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};